import React, { useEffect, useState, useContext } from "react";
import FontAwesome from "react-fontawesome";
import BranchContext from "../context/branch";
import { toast } from "react-toastify";
import {
  getOSMacSelected,
  getChipMacSelected,
  getModelMacSelected,
  getSiteSelected,
  getLocationSelected,
  getSoftwareMac,
  saveMacbookRegister,
  getManuallist,
  GetMyRegis,
  deleteMacRegist,
} from "../../services/pc";
import ImageSelected from "./imageselected";
import Select from "../common/selectcustom1";
import Input from "../common/useform/inputcustom";
import Inputmask from "../common/useform/inputmaskcustom";
import InputCheck from "../common/checkbox";
import ModelAlert from "../common/popupAlert";
import ModalImage from "./modalshowimage2";
import InputMask from "react-input-mask";
import ModalDelete from "../common/confirmDelete";

function PhoneInput(props) {
  return (
    <InputMask 
      mask='** ** ** ** ** **' 
      value={props.value} 
      onChange={props.onChange}>
    </InputMask>
  );
}

const Macbookregis = () => {
  const { currentBranch } = useContext(BranchContext);
  const [sitelist, setSitelist] = useState([]);
  const [softwarelist, setsoftwarelist] = useState([]);
  const [doccomentlist, setdoccomentlist] = useState([]);
  const [chiplist, setchiplist] = useState([]);
  const [modellist, setmodellist] = useState([]);
  const [mylist, setmylist] = useState([]);
  const [deleteid, setdeleteid] = useState(0);
  const [oslist, setoslist] = useState([]);
  const [arealist, setarealist] = useState([]);
  const [formData, setFormData] = useState({ siteid: 0 });
  const [messageError, setmessageError] = useState({});
  const [messageWarning, setmessageWarning] = useState("");
  const [isOpenAlert, setisOpenAlert] = useState(false);
  const [isOpenList, setisOpenList] = useState(false);
  const [photos, setphotos] = useState([]);
  const [photos2, setphotos2] = useState([]);
  const [refresh, setrefresh] = useState(new Date());
  const [isopenDelete, setIsopenDelete] = useState(false);
  const [imagesave, setImagesave] = useState({
    extension: "",
    imagedata: null,
  });
  const [imagesave2, setImagesave2] = useState({
    extension: "",
    imagedata: null,
  });
  const notifyPhotoSelector = (files) => {
    setphotos(files);
  };
  const notifyPhotoSelector2 = (files) => {
    setphotos2(files);
  };

  const [loading, setloading] = useState(false);
  const [onsave, setonsave] = useState(false);
  useEffect(() => {
    if (!currentBranch) return;
    const loadRegister = async () => {
      const { data: result } = await getSiteSelected();
      if (result.status === "success") {
        setSitelist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadRegister = async () => {
      const { data: result } = await GetMyRegis();
      if (result) {
        setmylist(result);
      }
    };

    loadRegister();
  }, [currentBranch, refresh]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadRegister = async () => {
      const { data: result } = await getManuallist();
      if (result.status === "success") {
        setdoccomentlist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    if (formData.siteid === undefined) return;

    const loadRegister = async () => {
      const { data: result } = await getLocationSelected(formData.siteid);

      if (result.status === "success") {
        setarealist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch, formData.siteid]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadRegister = async () => {
      const { data: result } = await getOSMacSelected();
      if (result.status === "success") {
        setoslist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadRegister = async () => {
      const { data: result } = await getChipMacSelected();
      if (result.status === "success") {
        setchiplist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadRegister = async () => {
      const { data: result } = await getModelMacSelected();
      if (result.status === "success") {
        setmodellist(result.data.list);
      }
    };

    loadRegister();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;
    const loadRegister = async () => {
      const { data: result } = await getSoftwareMac();
      if (result) {
        setsoftwarelist(result);
      }
    };

    loadRegister();
  }, [currentBranch]);

  const handleSelectChange = (inputKey, data) => {
    if (!data) return;
    setFormData({
      ...formData,
      [inputKey]: JSON.parse(data),
    });

    if (JSON.parse(data) !== 0) {
      setmessageError({ ...messageError, [inputKey]: "" });
    }
  };
  const patternValidation = (val) => {
    return /\s/g.test(val);
  };
  const handleInputChange = (inputKey, data, validate, chkhex) => {
    console.log(inputKey, data, validate, chkhex);
    const isValid = patternValidation(data);

    if (chkhex) {
      if (/^[0-9a-f]+$/.test(data) || data === "") {
        setFormData({
          ...formData,
          [inputKey]: data,
        });
      }
    } else {
      setFormData({
        ...formData,
        [inputKey]: data,
      });
    }

    if (validate) {
      if (isValid) {
        setmessageError({
          ...messageError,
          [inputKey]: "Empty spaces are not allowed",
        });
        return;
      }
    }
    if (data) {
      setmessageError({ ...messageError, [inputKey]: "" });
      setmessageWarning("");
      setisOpenAlert(false);
    }
  };

  const handelCheck = (event) => {
    const subproductlist = [...softwarelist];
    const index = subproductlist.findIndex((item) => item.id === event);
    let checkselected = subproductlist.filter((item) => item.id === event);
    subproductlist[index] = {
      ...checkselected[0],
      checked: !checkselected[0].checked,
    };
    setsoftwarelist(subproductlist);
  };
  function getBool(val) {
    return !!JSON.parse(String(val).toLowerCase());
  }
  let extension = "";
  const confirmUploadImage = async (id) => {
    const getPhoto = photos.find((x) => x);
    const getPhoto2 = photos2.find((x) => x);
    let photoBase64 = "";
    try {
      if (id === 1) {
        photoBase64 = getPhoto ? await getPhoto.getFileEncodeDataURL() : "";
      } else {
        photoBase64 = getPhoto2 ? await getPhoto2.getFileEncodeDataURL() : "";
      }
    } catch (err) {}

    if (photoBase64.includes("data:image/png;base64,")) {
      extension = "png";
      photoBase64 = photoBase64.replace("data:image/png;base64,", "");
    } else if (photoBase64.includes("data:image/jpg;base64,")) {
      extension = "jpg";
      photoBase64 = photoBase64.replace("data:image/jpg;base64,", "");
    } else if (photoBase64.includes("data:image/jpeg;base64,")) {
      extension = "jpeg";
      photoBase64 = photoBase64.replace("data:image/jpeg;base64,", "");
    }
    if (photoBase64.includes("data:application/pdf;base64,")) {
      extension = "pdf";
      photoBase64 = photoBase64.replace("data:application/pdf;base64,", "");
    }
    const docSave = { extension, imagedata: photoBase64 };
    if (id === 1) {
      setImagesave(docSave);
    } else {
      setImagesave2(docSave);
    }
  };

  const handelOnSave = () => {
    if (!formData.siteid) {
      setmessageWarning("ระบุ site ด้วยค่ะ");
      // setisOpenAlert(true);
      setmessageError({ ...messageError, siteid: true });
      return;
    } else if (!formData.areaid) {
      setmessageWarning("ระบุ location ด้วยค่ะ");
      // setisOpenAlert(true);
      setmessageError({ ...messageError, areaid: true });
      return;
    } else if (!formData.devicename) {
      setmessageError({
        ...messageError,
        devicename: "ระบุชื่อเครื่องด้วยค่ะ",
      });
      return;
    } else if (!formData.wirelessmac) {
      setmessageError({
        ...messageError,
        wirelessmac: "ระบุ Mac Address ด้วยค่ะ",
      });
      return;
    } else if (!formData.macos) {
      setmessageError({ ...messageError, macos: "ระบุ Mac OS ด้วยค่ะ" });

      return;
    } else if (!formData.versionnum) {
      setmessageError({
        ...messageError,
        versionnum: "ระบุชื่อเครื่องด้วยค่ะ",
      });
      return;
    } else if (!formData.sn) {
      setmessageError({ ...messageError, sn: "ระบุชื่อเครื่องด้วยค่ะ" });
      return;
    } else if (!formData.chip) {
      setmessageError({ ...messageError, chip: "ระบุชื่อเครื่องด้วยค่ะ" });
      return;
    } else if (!formData.model) {
      setmessageError({ ...messageError, model: "ระบุชื่อเครื่องด้วยค่ะ" });
      return;
    } else if (!formData.ram) {
      setmessageError({ ...messageError, ram: "ระบุชื่อเครื่องด้วยค่ะ" });
      return;
    } else if (!formData.hdd) {
      setmessageError({ ...messageError, hdd: "ระบุชื่อเครื่องด้วยค่ะ" });
      return;
    } else if (!imagesave.imagedata && !imagesave2.imagedata) {
      setmessageWarning("กรุณาupload รูปหน้าจออย่างน้อย 1 รูปค่ะ");
      setisOpenAlert(true);
      return;
    }
    const softwareselect = softwarelist.filter((item) => item.checked);

    const doc = {
      ...formData,
      extension: imagesave.extension,
      imagedata: imagesave.imagedata,
      extensio2: imagesave2.extension,
      imagedata2: imagesave2.imagedata,
      softwarelist: softwareselect,
    };
    doSubmit(doc);
  };

  const doSubmit = async (doc) => {
    try {
      setonsave(true);
      const { data: result } = await saveMacbookRegister(doc);
      if (result.status === "success") {
        toast.success(result.message);
        // setonsave(false);
        setrefresh(new Date());
        setphotos([]);
      } else {
        toast.error(result.message);
        setonsave(false);
      }
    } catch (err) {
      toast.error(err);
    }
  };
  const handleonOK = () => {
    setmessageWarning("");
    setisOpenAlert(false);
  };

  const handleClick = () => {
    setisOpenList(true);
  };
  const handelImageClose = () => {
    setisOpenList(false);
  };

  const handlerClick = (id) => {
    setdeleteid(id);
    setIsopenDelete(true)
  };
  const handleNumberChange = (e) => {
    let name = e.target.value;
    // console.log(e)
    if (e.target.value.match(/^[0-9a-f]+$/)) {
      e.target.value = name.slice(0, name.length - 1);
      setFormData({
        ...formData,
        lanmac: e.target.value.toUpperCase(),
      });
    }
    console.log(name);
    // this.setState({
    //   Name: e.target.value.toUpperCase()
    // });
    // if (e.target.value === "") {
    //   this.setState({
    //     Name: "Your NAME"
    //   });
    // }
  };
  const onConfirmDelete = () => {
    Confrimdelete();
  };
  const Confrimdelete = async () => {
    const doc = {
      id: deleteid,
    };

    try {
      setonsave(true);
      const { data: result } = await deleteMacRegist(doc);
      if (result.status === "success") {
        toast.success(result.message);
        setonsave(false);
        setrefresh(new Date());
        setIsopenDelete(false);
      
      } else {
        toast.error(result.message);
        setonsave(false);
      }
    } catch (err) {
      toast.error(err);
    }
  };

  
  const cancelDelete = () => {
    setIsopenDelete(false);
    setdeleteid(0);
  };

  const [phone, setPhone] = useState('');
  const handleInput = ({ target: { value } }) => {
    let name = value;
    if (name.match(/[0-9a-f]/g)) {
      const valuehex = name.match(/[0-9a-f]/g);
      let values="";
      for (const dataObj of valuehex) {
       const data =dataObj  
        values= values+data
       
       
      }
      setPhone(values.toUpperCase());
      setFormData({
        ...formData,
        lanmac: values.toUpperCase(),
      });

    //   console.log('total values',values)

    //  value = name.slice(0, name.length - 1);
    //  console.log('value leng',value.replace("-","").length)
    //  console.log('value ',value)
    //  console.log('test',/[0-9a-f]/.test(value))
    //  const oldvalue =value.slice(0,value.length - 1);
    //  console.log('old',oldvalue)
    //  if (/[0-9a-f]/.test(value) || value === "") {
    //   setPhone(value);
    // }
    //  if (value ){
    //   setPhone(value);
    //  }
      // setFormData({
      //   ...formData,
      //   lanmac: e.target.value.toUpperCase(),
      // });

      // setPhone(value);
    }
   
  }
  return (
    <>
      <ModalDelete
        isOpen={isopenDelete}
        onCancel={cancelDelete}
        onConfirm={onConfirmDelete}
      />
      <ModalImage
        isOpen={isOpenList}
        header={"รูปภาพ"}
        onCancel={handelImageClose}
        list={doccomentlist}
      />

      <ModelAlert
        isOpen={isOpenAlert}
        onOk={handleonOK}
        message={messageWarning}
      />
      <div className="row ">
        <div className="col-lg-6 col-sm-6">
          <div className="card text-center border-secondary">
            <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-success">
              <FontAwesome name="laptop"> </FontAwesome>{" "}
              <span className="ms-2">{"สถานที่ทำงาน"}</span>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-lg-6 mt-2">
                  <Select
                    label="Site"
                    data={sitelist}
                    value={formData.siteid}
                    name={"siteid"}
                    onChange={handleSelectChange}
                    error={messageError.siteid}
                  />
                </div>

                <div className="col-lg-6 mt-2">
                  <Select
                    label="Location"
                    data={arealist}
                    value={formData.areaid}
                    name={"areaid"}
                    onChange={handleSelectChange}
                    error={messageError.areaid}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-1"></div>
          <div className="card text-center border-secondary">
            <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-info">
              <FontAwesome name="laptop"> </FontAwesome>{" "}
              <span className="ms-2">{"ข้อมูลเครื่อง(Hardware)"}</span>
              <span
                className="ms-2 text-danger"
                style={{ cursor: "pointer" }}
                onClick={handleClick}
              >
                {"   คลิกดูตัวอย่างได้ที่นี่"}{" "}
                <FontAwesome name="hand-o-right"> </FontAwesome>{" "}
              </span>
            </div>
            <div className="card-body">
              <div className="row">
                {/* <div className="col-lg-6 mt-2">
                  <Select fa-hand-o-right
                    label="Site"
                    data={sitelist}
                    value={formData.siteid}
                    name={"siteid"}
                    onChange={handleSelectChange}
                    error={messageError.siteid}
                  />
                </div>

                <div className="col-lg-6 mt-2">
                  <Select
                    label="Location"
                    data={arealist}
                    value={formData.areaid}
                    name={"areaid"}
                    onChange={handleSelectChange}
                    error={messageError.areaid}
                  />
                </div> */}

                <div className="col-lg-6 mt-2">
                  <Input
                    label="1.DeviceName"
                    placeholder="ระบุชื่อเครื่อง"
                    name="devicename"
                    value={formData.devicename}
                    onChange={handleInputChange}
                    error={messageError.devicename}
                  />
                </div>
                <div className="col-lg-6 mt-2">
                  <Select
                    label="2.chip"
                    data={chiplist}
                    value={formData.chip}
                    name={"chip"}
                    onChange={handleSelectChange}
                    error={messageError.chip}
                  />
                </div>

                <div className="col-lg-6 mt-2">
                  <Input
                    label="3.Memmory(GB)"
                    placeholder="Memmory"
                    name="ram"
                    type="number"
                    value={formData.ram}
                    onChange={handleInputChange}
                    error={messageError.ram}
                  />
                </div>
                <div className="col-lg-6 mt-2">
                  <Input
                    label="4.serial number"
                    placeholder="serial number"
                    name="sn"
                    value={formData.sn}
                    onChange={handleInputChange}
                    error={messageError.sn}
                  />
                </div>

                <div className="col-lg-6 mt-2">
                  <Select
                    label="5.mac OS"
                    data={oslist}
                    value={formData.macos}
                    name={"macos"}
                    onChange={handleSelectChange}
                    error={messageError.macos}
                  />
                </div>

                <div className="col-lg-6 mt-2">
                  <Input
                    label="6.version number"
                    placeholder="version number"
                    name="versionnum"
                    type="number"
                    value={formData.versionnum}
                    onChange={handleInputChange}
                    error={messageError.versionnum}
                  />
                </div>

                <div className="col-lg-6 mt-2">
                  <Input
                    label="7.Storage (GB)"
                    placeholder="Storage"
                    name="hdd"
                    type="number"
                    value={formData.hdd}
                    onChange={handleInputChange}
                    error={messageError.hdd}
                  />
                </div>

                <div className="col-lg-6 mt-2">
                  <Select
                    label="8.รุ่น Model"
                    data={modellist}
                    value={formData.model}
                    name={"model"}
                    onChange={handleSelectChange}
                    error={messageError.model}
                  />
                </div>

                <div className="col-lg-6 mt-2">
                  {/* <InputMask
                    name="lanmac"
                    mask="** ** ** ** ** **"
                    value={formData.lanmac}
                    // maxLength="20"
                    maskChar=""
                    placeholder="MAC Address LAN"
                    onChange={handleNumberChange}
                  /> */}

{/* <PhoneInput 
        value={phone} 
        onChange={handleInput}>
      </PhoneInput> */}

                  <Input
                    label="9.MAC Address LAN"
                    placeholder="MAC Address LAN"
                    name="lanmac"
                    maxLength={12}
                    value={formData.lanmac}
                    onChange={handleInputChange}
                    error={messageError.lanmac}
                    chkhex={true}
                  />
                </div>
                <div className="col-lg-6 mt-2">
                  <Input
                    label="10.MAC Address WIFI"
                    placeholder="MAC Address WIFI"
                    name="wirelessmac"
                    maxLength={12}
                    value={formData.wirelessmac}
                    onChange={handleInputChange}
                    error={messageError.wirelessmac}
                    chkhex={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-sm-6">
          <div className="mt-1"></div>
          <div className="card text-center border-secondary">
            <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-warning">
              <FontAwesome name="file-text"> </FontAwesome>{" "}
              <span className="ms-2">{"ข้อมูลโปแกรมใช้งาน(Software)"}</span>
            </div>
            <div className="card-body">
              {softwarelist &&
                softwarelist.length > 0 &&
                softwarelist.map((item, index) => {
                  return (
                    <div className="row" key={index}>
                      <div className="col-lg-12    d-flex align-items-center mt-2">
                        <InputCheck
                          checked={getBool(item.checked)}
                          onChange={() => handelCheck(item.id)}
                        />

                        <span
                          className="badge text-primary rounded-pill"
                          style={{ fontSize: 12 }}
                        >
                          {index + 1}
                        </span>
                        <span className="ms-2" style={{ fontSize: 15 }}>
                          {item.name}
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div className="col-lg-12 col-sm-6">
          <div className="mt-1"></div>
          <div className="card text-center border-secondary">
            <div className="card-mb-4 d-flex align-items-center justify-content-center h-100 bg-info">
              <FontAwesome name="desktop"> </FontAwesome>{" "}
              <span className="ms-2">{"Upload รูปภาพ (Capture screen)"}</span>
            </div>
            <div className="card-body row mt-2 d-flex justify-content-center ">
              <div className="col-lg-4">
                <ImageSelected
                  labelIdle={imagesave.imagedata ? "Success" : "Upload รูปภาพ1"}
                  notifyFileUpload={notifyPhotoSelector}
                />
                {photos && photos.length > 0 && (
                  <div className="col-lg-6 text-center mb-3">
                    {" "}
                    <button
                      type="button"
                      className="btn btn-primary fs-4  p-1"
                      onClick={() => confirmUploadImage(1)}
                    >
                      <span className="m-3 ">Confirm</span>
                    </button>
                  </div>
                )}
              </div>
              <div className="col-lg-4">
                <ImageSelected
                  labelIdle={
                    imagesave2.imagedata ? "Success" : "Upload รูปภาพ2"
                  }
                  notifyFileUpload={notifyPhotoSelector2}
                />
                {photos2 && photos2.length > 0 && (
                  <div className="col-lg-6 text-center mb-3">
                    {" "}
                    <button
                      type="button"
                      className="btn btn-primary fs-4  p-1"
                      onClick={() => confirmUploadImage(2)}
                    >
                      <span className="m-3 ">Confirm</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-2 d-flex justify-content-center">
        <div className="col-lg-6 col-md-6  card border-0 mb-2 mt-1 ">
          <button
            type="button"
            className="btn btn-primary btn-lg"
            disabled={loading || onsave}
            onClick={() => handelOnSave()}
          >
            <span className="me-2">
              <FontAwesome name="save" />
            </span>
            <span>บันทึก</span>
          </button>
        </div>
      </div>

      {mylist && mylist.length > 0 && (
        <>
          <div className="col-auto">
            <span className="bg-info">
              <span className="me-2"></span>
              <span>รายการของฉัน</span>
            </span>
          </div>

          {mylist.map((item, index) => {
            return (
              <div className="row" key={index}>
                <div className="card shadow m-2 ">
                  <div className="row m-2 ">
                    <div className="col-xs-6   col-lg-2 ">
                      <span className="badge rounded-pill mb-1 bg-primary ">
                        {index+1}
                      </span>
                      <span className="badge text-primary fs-6  me-2">
                        ข้อมูลลงทะเบียน
                      </span>
                      <div
                        className="text-primary"
                        style={{ fontSize: 16, fontWeight: "bold" }}
                      />
                    </div>
                    <div className="col-xs-6   col-lg-2 ">
                      <div>
                        <h6>
                          วันที่ลงทะเบียน :
                          <small style={{ fontSize: 14 }}>
                            {" "}
                            {item.createdate}{" "}
                          </small>
                        </h6>
                      </div>
                      <div>
                        <h6>
                          ชื่อเครื่อง :
                          <small style={{ fontSize: 14 }}>
                            {item.devicename}
                          </small>
                        </h6>
                      </div>
                      <div>
                        <h6>
                          Chip :
                          <small style={{ fontSize: 14 }}>
                            {" "}
                            {item.chipname}
                          </small>
                        </h6>
                      </div>
                      <div />
                    </div>
                    <div className="col-xs-6   col-lg-2">
                      <div>
                        <h6>
                          SN :<small style={{ fontSize: 14 }}> {item.sn}</small>
                        </h6>
                      </div>
                      <div>
                        <div>
                          <h6>
                            Mac OS :
                            <small style={{ fontSize: 14 }}>
                              {item.osname}{" "}
                            </small>
                          </h6>
                        </div>
                      </div>
                      <div>
                        <div>
                          <h6>
                            Version No :
                            <small style={{ fontSize: 14 }}>
                              {item.versionnum}{" "}
                            </small>
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-6   col-lg-2">
                      <div>
                        <h6>
                          Storage :
                          <small style={{ fontSize: 14 }}>{item.storage}</small>
                        </h6>
                      </div>

                      <div>
                        <h6>
                          Model :
                          <small style={{ fontSize: 14 }}>
                            {" "}
                            {item.modelname}
                          </small>
                        </h6>
                      </div>
                      <div>
                        <h6>
                          Mac LAN :<span className="">{item.lanmac}</span>
                        </h6>
                      </div>
                    </div>
                    <div className="col-xs-6   col-lg-2 ">
                      <h6 className="d-flex justify-content-between">
                        Mac WIFI :<span className="">{item.wirelessmac}</span>
                      </h6>

                      {/* <h6 className="d-flex justify-content-between">
              CR :<span className="badge bg-warning text-black  ">รออนุมัติ</span>
            </h6>

            <h6 className="d-flex justify-content-between m-0">
              สถานะ :<span className="badge bg-warning text-black ">รออนุมัติ</span>
            </h6> */}
                    </div>
                    <div className="col-xs-6   col-lg-2  d-flex align-items-center d-flex justify-content-end">
                      <i
                        className="bi bi-trash-fill fs-3 text-danger m-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => handlerClick(item.id)}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

export default Macbookregis;
